import { cn } from "@/libs/cn";
import { ReactNode } from "react";

interface DetailFieldProps {
  label: string;
  children: ReactNode;
  className?: string;
  valueClassName?: string;
}

const DetailField = ({ label, children, className, valueClassName }: DetailFieldProps) => {
  return (
    <div className={cn("flex min-w-0 flex-col gap-1", className)}>
      <span className="text-sm text-ui-text">{label}</span>
      <div
        className={cn(
          "flex min-h-11 w-full min-w-0 items-center rounded-lg border border-ui-border bg-gray-50 px-3 py-2.5 text-sm text-ui-text-dark",
          valueClassName,
        )}
      >
        <span className="min-w-0 wrap-break-word">{children === null || children === undefined || children === "" ? "-" : children}</span>
      </div>
    </div>
  );
};

export default DetailField;
